import {
  TextField,
  Typography,
  Button,
  Stack,
  IconButton,
  Modal,
} from "@mui/material";
import { maskCpf, validateCpfCnpj } from "utils/Masks/Masks";
import { useContext } from "react";
import ApiContext from "api";
import { useState } from "react";
import { toast } from "react-toastify";
import { IconEnterprise } from "components/Icons/IconEnterprise";
import HelpModal from "components/DataDisplay/HelpModal/HelpModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "hooks/useAuth";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useConsigazApi } from "hooks/useConsigazApi";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import ForgotMyPassword from "../LoginStepPassword/ForgotMyPassword/ForgotMyPassword";
import ClienteService from "services/cliente";
import { AuthService } from "context/AuthContext/AuthContext";
import LoginStepClientCode from "./LoginStepCpfCnpj";

export default function IndustrialAccess({
  onSuccessConsultCpfCnpj,
  cnpj,
  onBack,
  userDataConsulta,
}) {
  const router = useHistory();
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [isCpfValid, setIsCpfValid] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const api = useConsigazApi();
  const { ConsigazApi } = useContext(ApiContext);
  const [isOpenFail, setIsOpenFail] = useState(false);
  const [isOpenForgotPassword, setIsOpenForgotPassword] = useState(false);
  const { isAdm, setIsAdm } = useAuth();
  const featureFlagNovaFormaAcessoIndustrial = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_INDUSTRIAL === "true";
  const normalizedCnpj = cnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  const normalizedCpf = cpfCnpj.replace(/\D/g, "");
  const cleanCpfcnpj = cpfCnpj.replace(/[^\d]+/g, "");

  const handleLegacyStep = async() => {
    try {
      const { Cliente } = await ConsigazApi.consultaLocalEntrega(normalizedCnpj);
      onSuccessConsultCpfCnpj(Cliente.ClienteRetorno[0], normalizedCnpj);
      return Cliente;
    } catch(error) {
      return undefined;
    }
  };

  const handleSubmit = async () => {
    if (!isCpfValid)
      return toast.error(
        "CPF ou CNPJ inválido. Verifique se digitou todos os números corretamente."
      );

    try {
      const response = await ConsigazApi.retornaAdmIndustrial(
        normalizedCpf,
        normalizedCnpj
      );

      const isAdm = Object.hasOwn(response, "administrador");
      setIsAdm(isAdm);

      const commonUserLocais = (response.UsuarioComumIndustrial ?? []).filter(
        (item) => String(item.CPF || "").replace(/\D/g, "") === normalizedCpf
      );

      const allUnits = commonUserLocais.map((local) => local["Local-entrega"]);

      AuthService.setIndustrialLinkedUnits(allUnits);
      if (response) {
        const success = await login({
          password,
          cpfCnpj: cleanCpfcnpj,
          type: "INDUSTRIAL",
        });

        if (success) {
          const response = await api.consultaLocalEntrega(
            normalizedCnpj,
            allUnits
          );

          const { Cliente } = response;
          try {
            const { Cliente: contatosCliente } = await api.consultaContatos(
              normalizedCnpj
            );
            const contatos =
              contatosCliente?.ClienteRetorno?.[0]?.ClienteContatoRetorno || [];

            const contatosDoCpf = contatos.filter(
              (contact) =>
                String(contact["cpf-contato"] || "").replace(/[^\d]/g, "") ===
                normalizedCpf
            );
            const contatosCandidatos = contatosDoCpf.length
              ? contatosDoCpf
              : contatos;

            const contatoBase = contatosCandidatos[0];
            const contatoComEmail = contatosCandidatos.find(
              (contact) => !!contact["e-mail"]
            );
            const contatoComTelefone = contatosCandidatos.find(
              (contact) => !!contact.telefone
            );

            if (contatoBase) {
              ClienteService.industrialContato = {
                sequencia: contatoBase.sequencia,
                name: contatoBase.nome,
                cpf: contatoBase["cpf-contato"] || normalizedCpf,
                phoneNumber:
                  contatoComTelefone?.telefone || contatoBase.telefone,
                department: contatoBase.tipo,
                email:
                  contatoComEmail?.["e-mail"] ||
                  contatoBase["e-mail"] ||
                  Cliente?.ClienteRetorno?.[0]?.email,
              };
            } else {
              ClienteService.industrialContato = {
                cpf: normalizedCpf,
                email: Cliente?.ClienteRetorno?.[0]?.email,
              };
            }
          } catch (error) {
            ClienteService.industrialContato = { cpf: normalizedCpf };
            console.warn("Erro ao buscar contato industrial:", error);
          }

          //if (ClienteService.redirectIfDocNotLinked(response, router)) return;

          router.push({
            pathname: "/existent-client",
            state: { cliente: Cliente.ClienteRetorno[0] },
          });
        }
      }
    } catch (error) {
      console.log(error);

      if (
        error === "não é Administrador do CNPJ informado" ||
        error === "não pertence ao código do cliente enviado"
      ) {
        setPassword("");
        setCpfCnpj("");
        setIsOpenFail(true);
      }
    }
  };

  //     const handleLogin = async () => {
  //   const cleanCpfcnpj = cpfCnpj.replace(/[^\d]+/g, "");
  //   try {
  //     const success = await login({
  //       password,
  //       cpfCnpj: segment === "CONTASIM" ? cleanCpfcnpj : cpfAccess,
  //       type: segment,
  //     });
  //     if (success) {
  //       const { Cliente } = await api.consultaLocalEntrega(cleanCpfcnpj);

  //       router.push({
  //         pathname: "/existent-client",
  //         state: { cliente: Cliente.ClienteRetorno[0] },
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error during login:", error);
  //   }
  // };

  if (!featureFlagNovaFormaAcessoIndustrial) {
    handleLegacyStep();
    return (
      <>
        <LoginStepClientCode
          segment={"INDUSTRIAL"}
          cpfCnpj={cpfCnpj}
          cpfAccess={""}
        />
      </>
    );
  }

  if (isOpenForgotPassword) {
    return (
      <>
        <IconButton
          onClick={() => setIsOpenForgotPassword(false)}
          sx={{ position: "absolute", p: 0, top: 60, left: 100 }}
        >
          <ArrowBackIcon sx={{ color: "#fff", fontSize: "31px" }} />
        </IconButton>
        <ForgotMyPassword
          segment={"INDUSTRIAL"}
          cpfCnpj={cnpj}
          email={userDataConsulta.email}
          cpfAccess={""}
          onBack={() => setIsOpenForgotPassword(false)}
          requestCpf={true}
        />
      </>
    );
  }

  return (
    <>
      <IconButton
        onClick={onBack}
        sx={{ position: "absolute", p: 0, top: 60, left: 100 }}
      >
        <ArrowBackIcon sx={{ color: "#fff", fontSize: "31px" }} />
      </IconButton>
      <Typography
        sx={{ width: "100%", textAlign: "justify" }}
        color="#FFFFFF"
        fontSize="30px"
        fontWeight={700}
        mb="30px"
      >
        Bem-vindo(a) à sua conta industrial!
      </Typography>
      <Typography
        color="#FFFFFF"
        fontSize={"16px"}
        fullWidth
        textAlign={"justify"}
        mb={"40px"}
      >
        Identificamos que este CNPJ já possui cadastro e está associado a uma
        conta industrial.
        <br />
        <br />
        Para validar seu acesso existente, informe seu CPF e Senha.
      </Typography>
      <Stack
        backgroundColor="#FFFFFF0D"
        p="24px"
        borderRadius="8px"
        mt="20px"
        direction="row"
        alignItems="center"
        width={"95%"}
      >
        <IconEnterprise width={"31px"} height={"31px"} color={"#FFFFFF"} />

        <Stack textAlign={"justify"} ml={"26px"} gap={"6px"}>
          <Typography color="#939393" fontSize="14px">
            CNPJ:
          </Typography>
          <Typography color="#FFFFFF" fontSize="20px" fontWeight={600}>
            {cnpj}
          </Typography>
        </Stack>
      </Stack>

      <Stack style={{ width: "100%", marginTop: "60px" }}>
        <TextField
          variant="standard"
          color="secondary"
          value={cpfCnpj}
          fullWidth
          onChange={(e) => {
            const maskedCpf = maskCpf(e.target.value);
            setIsCpfValid(validateCpfCnpj(maskedCpf));
            setCpfCnpj(maskedCpf);
          }}
          placeholder="CPF"
          sx={{
            "& input": {
              color: "gray",
            },
          }}
        />
        <TextField
          variant="standard"
          color="secondary"
          value={password}
          type="password"
          fullWidth
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Senha"
          sx={{
            "& input": {
              color: "gray",
            },
            mt: "28px",
          }}
        />
      </Stack>

      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "55px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 5,
        }}
        onClick={handleSubmit}
      >
        Avançar
      </Button>
      <Typography
        color="#2CABF9"
        fontWeight={600}
        fontSize={"15px"}
        mt={"30px"}
        mb={2}
        sx={{
          cursor: "pointer",
          zIndex: 1000,
        }}
        onClick={() => setIsOpenForgotPassword(true)}
      >
        Esqueci minha senha
      </Typography>
      <HelpModal open={openHelpModal} onClose={() => setOpenHelpModal(false)} />
      <Modal
        open={isOpenFail}
        onClose={() => setIsOpenFail(false)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"500px"}
          style={{ width: "auto" }}
          borderRadius={"8px"}
        >
          <Stack p={"32px"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              mb={"18px"}
            >
              <Typography
                fontSize={"20px"}
                fontWeight={700}
                fontStyle={"italic"}
              ></Typography>

              <IconButton onClick={() => setIsOpenFail(false)}>
                <CloseIcon
                  sx={{
                    color: "#053462",
                    fontSize: "31px",
                  }}
                />
              </IconButton>
            </Stack>
            <Stack sx={{ flexDirection: "column", gap: "20px" }}>
              <Typography
                fontSize={"24px"}
                color="primary.main"
                fontWeight={700}
              >
                Erro ao acessar conta
              </Typography>
              <Typography
                fontSize={"14px"}
                fontWeight={500}
                sx={{ color: "#636363" }}
              >
                Acesso não permitido, algum dado inserido ou erro impossibilitou
                seu acesso. Favor entrar em contato com administrador.
              </Typography>
            </Stack>
            <Stack justifyContent={"center"} alignItems={"center"} mt={"40px"}>
              <Button
                variant="text"
                sx={{
                  fontWeight: 700,
                  color: "#2CABF9",
                  fontSize: 18,
                }}
                onClick={() => {
                  setIsOpenFail(false);
                }}
              >
                Voltar para login
              </Button>
            </Stack>
          </Stack>
        </ContentModal>
      </Modal>
    </>
  );
}
